// OmniSound landing: the licence key is made BEFORE checkout and travels with the order (cart attributes),
// together with the device that opened the page from the app (?k=tv|pc|android&d=XXXX-XXXX).
(function () {
  var A = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
  function newKey() {
    var b = new Uint8Array(12), s = "";
    crypto.getRandomValues(b);
    for (var i = 0; i < 12; i++) s += A[b[i] % 32];
    return "OMNI-" + s.slice(0, 4) + "-" + s.slice(4, 8) + "-" + s.slice(8, 12);
  }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function init() {
    var keyEl = document.getElementById("om-key");
    if (!keyEl) return;
    var q = new URLSearchParams(location.search);
    var kind = q.get("k"), dev = (q.get("d") || "").toUpperCase();
    if (["tv", "pc", "android"].indexOf(kind) >= 0 && /^[0-9A-Z]{4}-[0-9A-Z]{4}$/.test(dev)) { store("om.kind", kind); store("om.dev", dev); }
    kind = store("om.kind"); dev = store("om.dev");
    var T = window.OM_TXT || {};
    var forEl = document.getElementById("om-for");
    if (kind && dev && forEl && T["for_" + kind]) { forEl.textContent = T["for_" + kind].replace("%CODE%", dev); forEl.hidden = false; }
    var key = store("om.key");
    if (!key) { key = newKey(); store("om.key", key); }
    keyEl.textContent = key;
    document.querySelectorAll("[data-om-buy]").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = b.getAttribute("data-om-buy");
        if (!v) { document.getElementById("om-soon").textContent = T.soon || ""; return; }
        var p = new URLSearchParams();
        p.set("attributes[Licence]", key);
        if (kind && dev) p.set("attributes[Device]", dev);
        location.href = "/cart/" + v + ":1?" + p.toString();
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

// motion: reveal on scroll (also for the sections that don't mark it), screen tabs
(function () {
  if (!("IntersectionObserver" in window)) return;
  document.documentElement.classList.add("om-js");
  var auto = ".om .om-head, .om-feat, .om-tile, .om-dev, .om-plan, .om-faq details, .om-rib, .om-final h2, .om-final p";
  function boot() {
    document.querySelectorAll(auto).forEach(function (e) { e.classList.add("om-reveal"); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("om-in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    var groups = new Map();
    document.querySelectorAll(".om-reveal").forEach(function (e) {
      var p = e.parentElement, i = groups.get(p) || 0;       // siblings come in one after another
      groups.set(p, i + 1);
      e.style.transitionDelay = Math.min(i, 8) * 70 + "ms";
      io.observe(e);
    });
    document.querySelectorAll("[data-om-tab]").forEach(function (b) {
      b.addEventListener("click", function () {
        var k = b.getAttribute("data-om-tab");
        document.querySelectorAll("[data-om-tab]").forEach(function (x) { x.classList.toggle("on", x === b); x.setAttribute("aria-selected", x === b ? "true" : "false"); });
        document.querySelectorAll("[data-om-pane]").forEach(function (p) { p.hidden = p.getAttribute("data-om-pane") !== k; });
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();

// floating "try free" button: shown after a little scroll (always on the other pages), tap opens the platforms on
// touch screens, the × hides it for this visit; hidden while the download / pricing section is on screen
(function () {
  function boot() {
    var el = document.getElementById("om-sticky");
    if (!el) return;
    var closed = false;
    try { closed = sessionStorage.getItem("om.sticky") === "x"; } catch (e) { /* private mode */ }
    if (closed) return;
    var home = !!document.getElementById("download");
    var visible = {};
    function update() {
      var over = visible.download || visible.pricing;
      var pw = document.querySelector(".page-wrapper"), y = Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0);
      el.hidden = !!over || (home && y < 500);       // on the home page the hero already has the button
    }
    ["download", "pricing"].forEach(function (id) {
      var t = document.getElementById(id);
      if (!t || !("IntersectionObserver" in window)) return;
      new IntersectionObserver(function (es) { visible[id] = es[0].isIntersecting; update(); }, { threshold: 0.15 }).observe(t);
    });
    window.addEventListener("scroll", update, { passive: true });
    var pw = document.querySelector(".page-wrapper");
    if (pw) pw.addEventListener("scroll", update, { passive: true });
    update();
    var btn = el.querySelector(".om-sticky__btn");
    btn.addEventListener("click", function (e) {
      if (window.matchMedia("(hover: none)").matches && !el.classList.contains("open")) { e.preventDefault(); el.classList.add("open"); }
    });
    document.addEventListener("click", function (e) { if (!el.contains(e.target)) el.classList.remove("open"); });
    el.querySelector(".om-sticky__x").addEventListener("click", function () {
      el.hidden = true;
      try { sessionStorage.setItem("om.sticky", "x"); } catch (e) { /* private mode */ }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
